<template>
  <div>
    <b-modal v-model="showModal" @hide="onHide"
      centered
      hide-footer
      title="New From Meta: MM Lite"
      :static="true"
      :hide-header-close="true"
      >
      <div v-if="step < 2" v-loading=loading>
        <div class="d-block text-center">
          <p>Meta secara resmi menggantikan layanan Marketing Message Cloud API menjadi MM Lite, sehingga layanan Marketing Message tidak lagi tersedia. MM Lite menawarkan optimasi otomatis dan limitasi message yang dinamis, memungkinkan pesan dengan high engagement rate menjangkau lebih banyak customer.</p><br/>
          <p>Pastikan bisnis Anda tetap berjalan optimal dengan melakukan migrasi ke MM Lite sebelum 10 Maret 2026. Silakan klik tombol di bawah untuk memulai.</p>
        </div>
        <hr/>
        <div class="text-center">
          <b-button variant="primary" class="cursor-pointer" @click="onSubmit">Start MM Lite</b-button>
        </div>
      </div>
      <div v-else>
        <div class="mb-4">
          <p>Silakan periksa akun FBBM Anda. Kami telah mengirimkan undangan yang perlu Anda setujui untuk melanjutkan proses aktivasi MM Lite.</p>
        </div>
        <div>
          <div v-b-toggle.collapse-1 variant="primary" class="d-flex justify-content-between align-items-center toggle-collapse" aria-expanded="false">
            <b>Panduan Pengaktifan MM Lite</b>
            <div style="font-size: 20px;">
              <i class="mdi mdi-chevron-down"></i>
              <i class="mdi mdi-chevron-up"></i>
            </div>
          </div>
          <b-collapse id="collapse-1" class="mt-2">
            <ol>
              <li>Ketika Anda klik tombol “Start MM Lite”. Sistem akan otomatis mengirimkan undangan ke akun FBBM Anda.</li>
              <li>Masuk ke FBBM, ke Menu Settings.</li>
              <li>Kemudian buka menu Request, lalu pilih Other Requests.</li>
              <li>Pada tab Received, akan muncul permintaan dari WAPPIN dengan keterangan: “Wappin has invited you to move your WhatsApp Business accounts to start sending marketing messages with optimisations.”</li>
              <li>Klik Review, lalu pilih Confirm.</li>
              <li>Informasi terkait MM Lite akan ditampilkan, klik Continue untuk melanjutkan.</li>
              <li>Pada tampilan Review Wappin's Access Request, klik Finish.</li>
              <li>MM Lite berhasil diaktifkan dan siap digunakan untuk pengiriman marketing message.</li>
            </ol>
          </b-collapse>
        </div>
        <small class="text-muted">Pesan ini akan muncul hingga proses persetujuan undangan selesai.</small>
        <hr/>
        <div class="d-flex justify-content-between float-right">
          <b-button class="mr-2" variant="secondary" @click="() => showModal = false">Close</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { toSvg } from 'jdenticon';

export default {
  name: 'ReminderMMLite',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
  },
  methods: {
    identicons(value) {
      return toSvg(value, '75');
    },
    onHide() {
      this.$emit('onHide');
    },
    onSubmit() {
      this.$emit('onSubmit');
    },
  },
  watch: {
    show() {
      this.showModal = this.show;
    },
  },
};
</script>

<style>
/* Change icon when the button is not collapsed (content is shown) */
.toggle-collapse[aria-expanded="true"] .mdi-chevron-down {
  display: none;
}

/* Change icon when the button is collapsed (content is hidden) */
.toggle-collapse[aria-expanded="false"] .mdi-chevron-up {
  display: none;
}
</style>
